import React from "react";
import { FormattedMessage } from "react-intl";
import type { Keyword } from "src/keywords/objects/Keyword";
import {
  type IRaangeLabelWithFAProps,
  RaangeLabel,
} from "src/shared/components/RaangeLabel";
import BooleanStatusFormatter from "src/shared/formatters/BooleanStatusFormatter";
import { Formatter } from "src/shared/formatters/Formatter";

export const KeywordLabel = (props: IRaangeLabelWithFAProps) => (
  <RaangeLabel fa="keyword-alt" {...props}>
    <FormattedMessage id="keywords" />
  </RaangeLabel>
);

export const KeywordCreate = (props: IRaangeLabelWithFAProps) => (
  <RaangeLabel fa="plus" {...props}>
    <FormattedMessage id="keywords.create" />
  </RaangeLabel>
);

export const KeywordEdit = (props: IRaangeLabelWithFAProps) => (
  <RaangeLabel fa="pencil-alt" {...props}>
    <FormattedMessage id="keywords.edit" />
  </RaangeLabel>
);

export interface IKeywordFormatterProps extends IRaangeLabelWithFAProps {
  children: Keyword;
}

export const KeywordType = ({ children }: IKeywordFormatterProps) => {
  const { actionLabel } = children;
  if (!actionLabel) {
    return <Formatter>{null}</Formatter>;
  }

  if (typeof actionLabel === "string") {
    return <Formatter>{actionLabel}</Formatter>;
  }

  return <Formatter>{actionLabel.name}</Formatter>;
};

export const KeywordStatus = ({ children }: IKeywordFormatterProps) => (
  <BooleanStatusFormatter>{children.flowStatus}</BooleanStatusFormatter>
);

export const KeywordCount = ({
  children: { keywordCount, actionId },
}: IKeywordFormatterProps) => {
  if (keywordCount === 0 && actionId === 5) {
    return (
      <Formatter notApplicable={<FormattedMessage id="ui.na" />}>
        {null}
      </Formatter>
    );
  }
  return <Formatter>{keywordCount}</Formatter>;
};
